<template>
  <div>
    <SideBarOption
      title="Inicio"
      url="/worker"
      :icon="{ icon: 'home', solid: false }"
    />
    <SideBarOption
      title="Notificaciones"
      url="/worker/blank"
      :icon="{ icon: 'bell', solid: false }"
    />
    <SideBarOption
      title="Publicar Servicio"
      url="/worker/service/create"
      :icon="{ icon: 'pencil', solid: false }"
    />
    <SideBarOption
      title="Editar Publicación"
      url="/worker/blank"
      :icon="{ icon: 'pencil-alt', solid: false }"
    />
    <SideBarOption
      title="Configuración"
      url="/worker/blank"
      :icon="{ icon: 'cog', solid: false }"
    />
    <a
      @click="logout"
      class="mt-1 group cursor-pointer flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
    >
      <IconSvg :solid="false" icon="logout" class="h-6 w-6 mr-2 mb-1 text-gray-400"/>
      Cerrar sesión
    </a>
  </div>
</template>

<script>
import SideBarOption from "./SideBarOption";
import IconSvg from "./IconSvg"

export default {
  components: {
    SideBarOption,
    IconSvg
  },
  methods: {
    logout() {
      localStorage.removeItem('jwt_token')
      localStorage.removeItem('user_id')
      localStorage.removeItem('user_name')
      localStorage.removeItem('user_level')
      this.$router.push("/login");
    }
  }
};
</script>